"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSearchParams = void 0;
const use_query_params_1 = require("use-query-params");
const useSearchParams = () => {
    const [searchParams, setSearchParams] = use_query_params_1.useQueryParams({
        page: use_query_params_1.NumberParam,
        query: use_query_params_1.StringParam,
        sort: use_query_params_1.StringParam,
        size: use_query_params_1.NumberParam,
        filters: use_query_params_1.ArrayParam
    });
    if (!searchParams.page) {
        delete searchParams.page;
    }
    if (!searchParams.query) {
        delete searchParams.query;
    }
    if (!searchParams.sort) {
        delete searchParams.sort;
    }
    if (!searchParams.size) {
        delete searchParams.size;
    }
    if (!searchParams.filters) {
        delete searchParams.filters;
    }
    return [searchParams, setSearchParams];
};
exports.useSearchParams = useSearchParams;
//# sourceMappingURL=useSearchParams.js.map